import classNames from 'classnames'
import Message from 'maeng-utils/locale'
import React from 'react'

const Introduction = () => {
  return (
    <section className={classNames('mt-4 mb-14', 'mt-14')}>
      <Message
        i18nKey="portfolio.introduction.title"
        className="text-xl text-[#ffaf19] font-bold border-solid border border-[#ffaf19] w-fit py-1 px-4 mb-3"
        component="h4"
      />
      <div className={classNames('pl-3', 'md:pl-6')}>
        <Message
          i18nKey="portfolio.introduction.greeting"
          values={{
            1: <p className="text-2xl font-bold leading-10 whitespace-pre" />,
            2: (
              <p className="text-2xl font-bold leading-8 whitespace-pre w-fit mb-6 highlight-[#ffaf1933]" />
            ),
          }}
        />
        <div>
          <Message
            i18nKey="portfolio.introduction.description.0"
            className="text-xl font-bold leading-8"
            component="div"
          />
          <ul>
            <Message
              i18nKey="portfolio.introduction.description.1"
              className="my-1"
              component="li"
              values={{
                1: <span className="text-xl font-bold leading-8 highlight-[#ff540026]" />,
                2: <span className="text-xl font-bold leading-8 highlight-[#ffaf1933]" />,
                3: <span className="text-xl font-bold leading-8 highlight-[#00960419]" />,
                4: <span className="text-xl font-bold leading-8 highlight-[#1a4bff19]" />,
                ul: <ul />,
                li: <li className="text-lg leading-8 check-list" />,
              }}
            />
          </ul>
        </div>
      </div>
    </section>
  )
}

export default Introduction
